import React, { useEffect } from "react";
import CaseList from "../components/CaseModule/CaseList";
import { Container, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";

const DisposedDecreedListPage = () => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("auth_token");
    if (!token) {
      setTimeout(() => {
        navigate("/login");
      }, 1000);
    }
  }, [navigate]);

  const enddate = "";
  const startDate = "";
  const casestatus = [1, 2];

  return (
    <CaseList
      Type={"Disposed-Decreed"}
      startdate={startDate}
      enddate={enddate}
      casestatusParam={casestatus}
      pageName={" Disposed-Decreed Case List"}
    />
  );
};

export default DisposedDecreedListPage;
